{
  "version": 1,
  "asset_id": "8d946a20-1666-4c61-b7b7-4fd0850d4550",
  "project_id": "affbb9b7-8892-4de7-a6a3-a24f8c559459",
  "url": "/__l5e/assets-v1/8d946a20-1666-4c61-b7b7-4fd0850d4550/scalinata-pietra-prima-pulizia-brescia.webp",
  "r2_key": "a/v1/affbb9b7-8892-4de7-a6a3-a24f8c559459/8d946a20-1666-4c61-b7b7-4fd0850d4550/scalinata-pietra-prima-pulizia-brescia.webp",
  "original_filename": "scalinata-pietra-prima-pulizia-brescia.webp",
  "size": 502774,
  "content_type": "image/webp",
  "created_at": "2026-09-02T15:20:49Z"
}
